"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A comunica mediator that runs all actors that resolve their test.
 * This mediator will always resolve to `null`.
 */


var MediatorAll =
/*#__PURE__*/
function (_core_1$Mediator) {
  _inherits(MediatorAll, _core_1$Mediator);

  function MediatorAll(args) {
    _classCallCheck(this, MediatorAll);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediatorAll).call(this, args));
  }

  _createClass(MediatorAll, [{
    key: "mediate",
    value: function () {
      var _mediate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var validActors, testResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, testResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Collect all actors that resolve their test
                validActors = [];

                try {
                  testResults = this.publish(action);
                } catch (e) {
                  testResults = [];
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;
                _iterator = testResults[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 20;
                  break;
                }

                testResult = _step.value;
                _context.prev = 9;
                _context.next = 12;
                return testResult.reply;

              case 12:
                validActors.push(testResult.actor);
                _context.next = 17;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](9);

              case 17:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                _context.next = 36;
                return Promise.all(validActors.map(function (actor) {
                  return actor.runObservable(action);
                }));

              case 36:
                return _context.abrupt("return", null);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 22, 26, 34], [9, 15], [27,, 29, 33]]);
      }));

      function mediate(_x) {
        return _mediate.apply(this, arguments);
      }

      return mediate;
    }()
  }, {
    key: "mediateWith",
    value: function () {
      var _mediateWith = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, testResults) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", null);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function mediateWith(_x2, _x3) {
        return _mediateWith.apply(this, arguments);
      }

      return mediateWith;
    }()
  }]);

  return MediatorAll;
}(core_1.Mediator);

exports.MediatorAll = MediatorAll;